(function () {
  'use strict';
  if (customElements.get('rocco-sticky-cart')) return;
  var overlaySelector = 'cart-drawer,cart-notification,product-modal,quick-add-modal,dialog,menu-drawer,details-modal';
  var previewSelector = '#PBarNextFrameWrapper,#preview-bar-iframe';

  function amount(text) {
    var value = (text || '').replace(/[^0-9.,]/g, '');
    var index = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
    var decimals = value.length - index - 1;
    if (index >= 0 && decimals > 0 && decimals <= 2) value = value.slice(0, index).replace(/[.,]/g, '') + '.' + value.slice(index + 1);
    else value = value.replace(/[.,]/g, '');
    return value ? Number(value) : NaN;
  }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }

  class RoccoStickyCart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.hidden = true;
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected) return;
      this.scope = document.getElementById('MainProduct-' + this.dataset.sectionId);
      if (!this.scope) return;
      try { this.product = JSON.parse(this.querySelector('[data-sticky-product]').textContent); } catch (_) { return; }
      this.button = this.querySelector('[data-sticky-add]');
      this.full = this.querySelector('[data-sticky-full]');
      this.short = this.querySelector('[data-sticky-short]');
      this.defaultFull = this.full.textContent;
      this.defaultShort = this.short.textContent;
      this.price = this.querySelector('[data-sticky-price]');
      this.selection = this.querySelector('[data-sticky-selection]');
      this.image = this.querySelector('[data-sticky-image]');
      this.error = this.querySelector('[data-sticky-error]');
      this.spacer = document.createElement('div');
      this.spacer.className = 'rocco-sticky-cart-spacer';
      this.spacer.setAttribute('aria-hidden', 'true');
      this.spacer.hidden = true;
      document.body.appendChild(this.spacer);
      this.schedule = this.schedule.bind(this);
      this.add = this.add.bind(this);
      this.button.addEventListener('click', this.add);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      document.addEventListener('visibilitychange', this.schedule);
      this.scope.addEventListener('variants-changed', this.schedule, true);
      this.scope.addEventListener('deal-bar-selected', this.schedule, true);
      this.scope.addEventListener('kaching-bundles-block-hydrated', this.schedule, true);
      this.scope.addEventListener('change', this.schedule, true);
      this.scopeObserver = new MutationObserver(this.schedule);
      this.scopeObserver.observe(this.scope, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'value', 'hidden'] });
      this.overlayObserver = new MutationObserver(this.schedule);
      this.observedOverlays = new WeakSet();
      this.watchOverlays();
      this.bodyObserver = new MutationObserver(records => {
        if (records.some(record => record.type === 'attributes' || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(overlaySelector + ',' + previewSelector) || node.querySelector(overlaySelector + ',' + previewSelector))))) {
          this.watchOverlays();
          this.schedule();
        }
      });
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.resizeObserver.observe(this);
      this.schedule();
    }
    watchOverlays() {
      document.querySelectorAll(overlaySelector + ',' + previewSelector).forEach(node => {
        if (this.observedOverlays.has(node)) return;
        this.observedOverlays.add(node);
        this.overlayObserver.observe(node, { attributes: true, subtree: true, attributeFilter: ['class', 'open', 'hidden', 'aria-hidden', 'style'] });
      });
    }
    blockedByOverlay() {
      if (document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile')) return true;
      return Array.from(document.querySelectorAll(overlaySelector)).some(node => {
        if (node.matches('cart-drawer,cart-notification')) return node.classList.contains('active');
        return node.hasAttribute('open') || !!node.querySelector('details[open]');
      });
    }
    schedule() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    findSource() {
      return document.getElementById('ProductSubmitButton-' + this.dataset.sectionId) || this.scope.querySelector('product-form button[type="submit"][name="add"]');
    }
    update() {
      if (!this.scope.isConnected) { this.remove(); return; }
      var source = this.findSource();
      if (!source) { this.setVisible(false); return; }
      if (this.source !== source) {
        this.source = source;
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        this.intersectionObserver = new IntersectionObserver(this.schedule);
        this.intersectionObserver.observe(source);
      }
      var busy = source.classList.contains('loading');
      var disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
      this.button.setAttribute('aria-busy', String(busy));
      var sourceLabel = source.querySelector('span');
      var stockLabel = disabled && !busy && sourceLabel ? sourceLabel.textContent.trim() : '';
      text(this.full, stockLabel || this.defaultFull);
      text(this.short, stockLabel || this.defaultShort);
      this.button.setAttribute('aria-label', (stockLabel || this.defaultFull) + ': ' + this.querySelector('[data-sticky-title]').textContent.trim());
      var nativeForm = source.closest('product-form');
      var nativeError = nativeForm && nativeForm.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
      var errorText = nativeError ? nativeError.textContent.trim() : '';
      text(this.error, errorText);
      if (this.error.hidden !== !errorText) this.error.hidden = !errorText;
      this.updateProduct(source);
      // Shopify's admin preview is a top-layer overlay; keep this CTA above it.
      var preview = document.querySelector(previewSelector);
      var previewRect = preview && preview.getBoundingClientRect();
      var previewOffset = previewRect && previewRect.height > 0 && previewRect.top > innerHeight / 2 ? Math.max(0, Math.ceil(innerHeight - previewRect.top)) : 0;
      var offset = previewOffset + 'px';
      if (this.style.getPropertyValue('--rocco-sticky-cart-preview-offset') !== offset) this.style.setProperty('--rocco-sticky-cart-preview-offset', offset);
      var rect = source.getBoundingClientRect();
      // Only activate after passing the original button, never before reaching it.
      var passed = source.getClientRects().length > 0 && rect.bottom <= 0;
      this.setVisible(passed && !this.blockedByOverlay());
    }
    updateProduct(source) {
      var form = source.form || source.closest('form');
      var variantInput = form && form.querySelector('[name="id"]');
      var variant = this.product.variants.find(item => String(item.id) === String(variantInput && variantInput.value));
      var minimum = variant ? variant.price / 100 : NaN;
      var widget = this.scope.querySelector('kaching-bundles-block:not(kaching-bundles-sticky-atc kaching-bundles-block)');
      var selectedTitle = '';
      var currency = this.product.currency;
      if (widget && widget.config && widget.dealBlock) {
        currency = widget.config.marketCurrencyCode || currency;
        var candidates = [];
        Array.from(widget.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar[data-deal-bar-id]')).forEach(bar => {
          if (bar.closest('.kaching-bundles__subscriptions') || bar.classList.contains('kaching-bundles__bar--disabled')) return;
          var selected = bar.classList.contains('kaching-bundles__bar--selected');
          if (selected) {
            var title = bar.querySelector('.kaching-bundles__bar-title');
            selectedTitle = title ? title.textContent.trim() : '';
          }
          var deal = (widget.dealBlock.dealBars || []).find(item => item.id === bar.dataset.dealBarId);
          if (!deal || (deal.dealBarType && deal.dealBarType !== 'quantity-break')) return;
          var quantity = Number(deal.quantity);
          if (selected && deal.quantitySelector) quantity = Number(widget.quantity) || quantity;
          var total = bar.querySelector('.kaching-bundles__bar-pricing .kaching-bundles__bar-price');
          if (!total || !Number.isFinite(quantity) || quantity <= 0) return;
          var value = amount(total.textContent);
          if (Number.isFinite(value) && value >= 0) candidates.push(widget.dealBlock.showPricesPerItem ? value : value / quantity);
        });
        if (candidates.length) minimum = Math.min.apply(Math, candidates);
      }
      var priceText = '';
      if (Number.isFinite(minimum)) {
        var rounded = Math.round((minimum + Number.EPSILON) * 100) / 100;
        var formatted = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: currency || 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rounded);
        priceText = this.dataset.from + ' ' + formatted + ' / ' + this.dataset.piece;
        this.price.dataset.price = String(rounded);
      }
      text(this.price, priceText);
      text(this.selection, selectedTitle ? this.dataset.selected + selectedTitle : '');
      if (this.selection.hidden !== !selectedTitle) this.selection.hidden = !selectedTitle;
      if (variant && variant.image && this.image && this.image.getAttribute('src') !== variant.image) this.image.setAttribute('src', variant.image);
    }
    setVisible(visible) {
      if (this.hidden === !visible) return;
      this.hidden = !visible;
      this.spacer.hidden = !visible;
      if (visible) this.updateHeight();
    }
    updateHeight() {
      if (!this.hidden && this.spacer) this.spacer.style.setProperty('--rocco-sticky-cart-height', Math.ceil(this.getBoundingClientRect().height) + 'px');
    }
    add() {
      var source = this.findSource();
      if (!source || this.button.disabled || source.disabled || source.getAttribute('aria-disabled') === 'true') return;
      // The native click preserves Kaching quantities, discounts, gifts and cart UI.
      source.click();
      this.schedule();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.source = null;
      if (this.schedule) {
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        document.removeEventListener('visibilitychange', this.schedule);
        if (this.scope) {
          this.scope.removeEventListener('variants-changed', this.schedule, true);
          this.scope.removeEventListener('deal-bar-selected', this.schedule, true);
          this.scope.removeEventListener('kaching-bundles-block-hydrated', this.schedule, true);
          this.scope.removeEventListener('change', this.schedule, true);
        }
      }
      ['scopeObserver', 'overlayObserver', 'bodyObserver', 'resizeObserver', 'intersectionObserver'].forEach(key => { if (this[key]) this[key].disconnect(); });
      if (this.button) this.button.removeEventListener('click', this.add);
      if (this.spacer) this.spacer.remove();
      this.initialized = false;
    }
  }
  customElements.define('rocco-sticky-cart', RoccoStickyCart);
})();
